export default __webpack_public_path__ + "static/media/ant-design.b9e0b6e8.svg";